import { render, staticRenderFns } from "./TokenList.vue?vue&type=template&id=56b0e84b&"
import script from "./TokenList.vue?vue&type=script&lang=ts&"
export * from "./TokenList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports